import { DropDown } from 'src/app/shared/model/base-model';
import { OnInit, Component, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { WoOrderServiceDefaultService } from '../wo-order-service-default.service';

@Component({
    selector: 'wo-order-service-default-dropdown',
    templateUrl: './wo-order-service-default-dropdown.component.html',
    styleUrls: ['./wo-order-service-default-dropdown.component.scss']
})

export class WoOrderServiceDefaultDropdownComponent implements OnInit, OnChanges {

    public list: DropDown[];
    @Input() placeHolderLanguage: string;
    public selectedItem: DropDown;

    @Input() id: string;
    @Input() disabled: boolean = false;
    @Output() chosedItem = new EventEmitter();

    constructor(private woOrderServiceDefaultService: WoOrderServiceDefaultService) { }

    ngOnInit(): void {
        this.getList();
    }

    ngOnChanges(): void {
        this.getList();
    }

    getList() {
        this.woOrderServiceDefaultService.getDropDownList().subscribe(
            {
                next: (res) => {
                    if (res)
                        this.list = res.data;
                    if (this.list !== null) {
                        this.selectedItem = this.list.find(x => x.id == this.id);
                        if (this.selectedItem == null || this.selectedItem.id == undefined) {
                            this.selectedItem = this.list[0];
                            this.feedback();
                            console.log(this.list);
                        }
                    }
                },
                error: (err) => {
                    console.log(`WoOrderServiceDefaultDropDown - getList : ${err}.`);
                }
            });
    }

    feedback() {
        this.chosedItem.emit(this.selectedItem)
    }

}

